import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { EventsService, VariablesService } from 'src/app/shared/services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-multi-patient-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule],
  templateUrl: './multi-patient-dropdown.component.html',
  styleUrls: ['./multi-patient-dropdown.component.scss']
})
export class MultiPatientDropdownComponent implements OnInit {

  options = [
    { label: '{{beneficiary}} or others', value: true },
    { label: 'Only {{beneficiary}}', value: false }
  ];

  basicForm: FormGroup;
  selected: FormControl;

  multi_patient_beneficiaries = [];

  isEventFired = false;

  qParams: any;

  constructor(
    private actRoute: ActivatedRoute,
    private events: EventsService,
    public vars: VariablesService
  ) { }

  ngOnInit(): void {
    this.qParams = { ...this.actRoute.snapshot.queryParams };
    if (this.qParams?.st === 'f' && this.qParams?.multi_patient_opted === '0') {
      this.vars.donateMultiPatient = false;
    } else {
      this.vars.donateMultiPatient = true;
    }
    this.actRoute.queryParams.subscribe(p => {
      this.setDetails();
    });
  }

  setDetails() {
    this.multi_patient_beneficiaries = this.vars.fundraiser?.multi_patient_beneficiaries || [];
    const beneficiaryname = this.vars.fundraiser?.beneficiaryname?.info_1 || 'this';
    // const beneficiaryname = this.vars.fundraiser?.beneficiaryname?.info_1?.split(' ')[0] || 'this';
    this.options[0].label = this.options[0].label.replace('{{beneficiary}}', beneficiaryname);
    this.options[1].label = this.options[1].label.replace('{{beneficiary}}', beneficiaryname);
    this.selected = new FormControl(this.vars.donateMultiPatient);
  }

  onChange() {
    this.vars.donateMultiPatient = this.selected.value;
  }

  clickEvent() {
    if (!this.isEventFired) {
      this.isEventFired = true;
      const payload = {
        eventName: 'multi_patient_dropdown_click',
        event_type_id: this.vars?.fundraiser?.id
        // info_1: this.vars.donateMultiPatient ? 'enabled' : 'disabled'
      };
      this.events.sendSystemEvent(payload).subscribe(_ => _);
    }
  }
}
